<template>
  <v-card
    class="login-dialog--login__content"
    :class="layout == 'portal' ? 'fixit-background-gradient' : ''"
    flat
    :style="!$vuetify.breakpoint.smAndDown ? 'height: 600px' : ''"
  >
    <v-app-bar flat color="rgba(0, 0, 0, 0)">
      <v-btn
        color="#472449"
        fab
        small
        rounded
        text
        @click="changeView('select_screen')"
        v-if="!(origin == 'fixitOAuth' || origin.includes('Homepages'))"
      >
        <v-icon size="30">fxt-chevron-left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn v-if="!isProfile" fab small color="#472449" icon @click="close">
        <v-icon size="30">fxt-close</v-icon>
      </v-btn>
    </v-app-bar>
    <div
      class="login-dialog--login__content-container"
      :class="
        $vuetify.breakpoint.smAndDown
          ? 'login-dialog--login__content-container--mobile-focus'
          : ''
      "
    >
      <transition mode="out-in" name="scroll-x-transition">
        <the-identifier
          key="check-user"
          title="Logg inn med din bruker"
          description="Skriv inn mobilnummer eller e-post"
          v-if="[state.ID].includes(currentForm) && hasMounted && !prefilledMobile"
          @setValue="setUsername"
          :error="error"
          @verify="VerifyStep()"
          :layout="layout"
          @hasFocus="inputHasFocus = true"
        ></the-identifier>
        <the-code
          key="verify-sms"
          v-if="[state.CODE].includes(currentForm)"
          title="Engangskode"
          description="Skriv inn engangskoden som du har mottatt på SMS."
          :error="error"
          :showResendText="showResendText"
          isSms
          @setValue="setCode"
          @changed="resetError()"
          @verify="VerifyStep()"
          :layout="layout"
        ></the-code>
        <the-email
          key="enter-email"
          v-if="[state.EMAIL].includes(currentForm)"
          title="Ny e-post"
          ref="validation"
          :description="
            addNewEmailProcessStarted
              ? 'Legg til ny e-post'
              : 'Vi mangler en e-post på din profil og vi trenger denne for å gjøre profilen din sikrere.'
          "
          @setValue="setEmail"
          :layout="layout"
          @verify="VerifyStep()"
          :error="error"
          :currentEmail="currentEmail"
          :addNewEmailProcess="addNewEmailProcessStarted"
        ></the-email>
        <the-code
          key="verify-email"
          v-if="[state.EMAILCODE].includes(currentForm)"
          title="Verifiser e-post"
          showJunkMailText
          :description="'Bekreft ved å taste engangskoden som du har mottatt fra oss på '"
          :error="error"
          :showResendText="showResendText"
          @changed="resetError()"
          :email="username.includes('@') ? username : email"
          :layout="layout"
          @setValue="setCode"
          @verify="VerifyStep()"
        ></the-code>
        <the-password
          key="create-password"
          title="Lag et passord"
          ref="validation"
          description="Passordet må inneholde minimum 8 tegn, minst ett tall og én stor bokstav."
          :layout="layout"
          v-if="[state.CREATEPASSWORD].includes(currentForm)"
          @setValue="setPassword"
          @verify="VerifyStep()"
        ></the-password>
        <the-password
          key="insert-password"
          title="Ditt passord"
          ref="validation"
          description="Vennligst oppgi passordet for din bruker"
          :layout="layout"
          :error="error"
          :requireValidation="false"
          v-if="[state.INSERTPASSWORD].includes(currentForm) && hasMounted"
          @setValue="setPassword"
          @verify="VerifyStep()"
        ></the-password>
        <welcome
          key="welcome-screen"
          v-if="[state.WELCOME].includes(currentForm)"
          @close="close()"
          title="Velkommen"
          description="Nå kan du bestille time og kjøpe produkter i våre 850 salonger."
        >
        </welcome>
        <the-code
          key="reset-verify-email"
          v-if="[state.RESETVERIFYEMAIL].includes(currentForm)"
          title="Er dette deg?"
          showJunkMailText
          :layout="layout"
          :showResendText="showResendText"
          :description="'Bekreft ved å taste engangskoden som du har mottatt fra oss på '"
          :email="username.includes('@') ? username : email"
          :error="error"
          @changed="resetError()"
          @setValue="setCode"
          @verify="VerifyStep()"
        ></the-code>
        <the-code
          key="reset-verify-mobile"
          v-if="[state.RESETVERIFYCODE].includes(currentForm)"
          title="Engangskode"
          description="Skriv inn engangskoden som du har mottatt på SMS."
          @setValue="setCode"
          isSms
          :showResendText="showResendText"
          :error="error"
          @verify="VerifyStep()"
          :layout="layout"
          @changed="resetError()"
        ></the-code>
      </transition>
      <div
        class="login-dialog--login__content-container--options"
        :class="
          !$vuetify.breakpoint.smAndDown
            ? 'login-dialog--login__content-container--options_limited'
            : ''
        "
      >
        <v-btn
          v-if="
            ![
              state.CODE,
              state.EMAILCODE,
              state.RESETVERIFYCODE,
              state.RESETVERIFYEMAIL,
            ].includes(currentForm)
          "
          :disabled="verifyInputFields()"
          elevation="0"
          block
          color="var(--v-primary-base)"
          dark
          rounded
          :class="!$vuetify.breakpoint.smAndDown ? 'my-3' : ''"
          @click="VerifyStep()"
        >
          Fortsett
        </v-btn>
        <transition mode="out-in" name="scroll-y-reverse-transition">
          <v-btn
            elevation="0"
            block
            color="var(--v-primary-base)"
            v-if="
              [state.EMAILCODE].includes(currentForm) &&
              !addNewEmailProcessStarted &&
              !loggingInWithEmail
            "
            dark
            outlined
            rounded
            class=""
            @click="resetEmail()"
          >
            Feil e-post? Legg til ny
          </v-btn>
        </transition>
        <transition mode="out-in" name="scroll-y-reverse-transition">
          <v-btn
            block
            color="var(--v-primary-base)"
            v-if="[state.CODE, state.EMAILCODE, state.RESETVERIFYCODE].includes(currentForm)"
            dark
            text
            rounded
            :class="
              !currentForm.includes(state.EMAILCODE) ? 'my-8' : 'mt-5 mb-2'
            "
            @click="resendCode()"
          >
            Send kode på nytt
          </v-btn>
        </transition>
        <transition mode="out-in" name="scroll-y-reverse-transition">
          <v-btn
            elevation="0"
            block
            color="var(--v-primary-base)"
            v-if="[state.INSERTPASSWORD].includes(currentForm)"
            dark
            text
            rounded
            class="mt-3"
            @click="resetPassword()"
          >
            Glemt passord?
          </v-btn>
        </transition>
      </div>
    </div>
  </v-card>
</template>
<script>
import {
  TheIdentifier,
  TheCode,
  TheEmail,
  ThePassword,
  Welcome,
} from "../../../Common/CommonSteps";
import AppSvc from "../../../../services/app-svc";

let service = null;

export default {
  name: "the-selection",
  components: {
    TheIdentifier,
    TheCode,
    TheEmail,
    ThePassword,
    Welcome,
  },
  props: {
    isTpn: {
      type: Boolean,
      required: true,
    },
    tpnChainId: {
      type: Number,
      required: true,
    },
    tpnSiteId: {
      type: Number,
      required: true,
    },
    isProfile: {
      type: Boolean,
      default: false,
      required: false,
    },
    apiUrl: {
      type: String,
      required: true,
    },
    layout: {
      required: false,
      type: String,
      default: "chain",
    },
    prefilledMobile: {
      required: false,
      type: String,
      default: "",
    },
    useAxios: Boolean,
  },
  data() {
    return {
      error: "",
      showResendText: false,
      inputHasFocus: false,
      addNewEmailProcessStarted: false,
      state: {
        ID: "check-user",
        CODE: "verify-sms",
        EMAILCODE: "verify-email",
        EMAIL: "enter-email",
        CREATEPASSWORD: "create-password",
        INSERTPASSWORD: "insert-password",
        WELCOME: "welcome-screen",
        RESETPASSWORD: "reset-password",
        RESETVERIFYCODE: "reset-verify-mobile",
        RESETVERIFYEMAIL: "reset-verify-email",

        RESET_EMAIL: "reset-email",
      },
      currentForm: "check-user",
      previousForm: "",
      username: "",
      code: "",
      email: "",
      password: "",
      clientIdentity: null,
      currentEmail: "",
      hasMounted: false
    };
  },
  computed: {
    loggingInWithEmail() {
      const emailRegexValidation =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return emailRegexValidation.test(this.username);
    },
    origin(){
      return localStorage.getItem('origin') ?? ''
    }
  },
  methods: {
    verifyInputFields() {
      switch (this.currentForm) {
        case "check-user":
          return this.username === "";
        case "enter-email":
          return (
            this.email === "" ||
            (this.currentEmail === this.email && this.addNewEmailProcessStarted)
          );
        case "create-password":
          return this.password === "";
        case "insert-password":
          return this.password === "";
        default:
          return false;
      }
    },
    resetError() {
      this.error = "";
    },
    setUsername(value) {
      this.error = "";
      this.username = value;
    },
    setCode(value) {
      this.code = value;
    },
    setEmail(value) {
      this.error = "";
      this.email = value;
    },
    setPassword(value) {
      this.error = "";
      this.password = value;
      this.$emit('setPassword', value)
    },
    changeView(state) {
      this.$emit("changeView", state);
    },
    close() {
      this.$emit("close");
    },
    VerifyStep(params = null) {
      var body = params ? params : {
        username: this.username,
        isTpn: this.isTpn.toString(),
        tpnChainId: this.tpnChainId.toString(),
        tpnSiteId: this.tpnSiteId.toString(),
        step: this.currentForm,
        password: this.password
      };

      if (this.currentForm.includes("verify")) {
        const emailRegexValidation =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var isValidEmail = emailRegexValidation.test(this.email);
        var isValidUsername = emailRegexValidation.test(this.username);
        Object.assign(body, {
          clientIdentity: this.clientIdentity,
          code: this.code,
          email: isValidEmail
            ? this.email
            : isValidUsername
            ? this.username
            : "",
        });
      }
      if (this.currentForm === "enter-email") {
        Object.assign(body, {
          email: this.email,
        });
      }
      if (
        this.$route.query.action &&
        this.$route.query.siteId &&
        this.$route.query.customerId
      ) {
        Object.assign(body, {
          siteId: this.$route.query.siteId,
          customerId: this.$route.query.customerId,
        });
      }
      if (
        [
          this.state.CODE,
          this.state.EMAILCODE,
          this.state.RESETVERIFYCODE,
          this.state.RESETVERIFYEMAIL,
          this.state.ID,
          this.state.INSERTPASSWORD,
          this.state.RESETPASSWORD,
          this.state.CREATEPASSWORD,
        ].includes(this.currentForm) ||
        this.$refs.validation.validate()
      ) {
        service.VerifyLoginStep(this.apiUrl, body).then((response) => {
          this.error = "";
          if (response.data.responseCode === 200) {
            this.showResendText = false
            var result = response.data;
            this.email = result.fixitNoUser?.email
              ? result.fixitNoUser?.email
              : this.email;
            if (result.nextStep == this.state.EMAILCODE) {
              this.currentEmail = result.fixitNoUser?.email;
            }
            if (result.nextStep == this.state.RESETVERIFYEMAIL && result.fixitNoUser?.email) {
              this.username = result.fixitNoUser?.email;
            }
            this.clientIdentity = result.clientIdentity;
            this.previousForm = this.currentForm;
            this.currentForm = result.nextStep;
            if (result.nextStep === "update-userdata") {
              this.$emit("setUpdateData", result.fixitNoUser);
            }
            if (result.nextStep === "welcome-screen") {
              this.$emit("setUser", result.fixitNoUser);
            }
          } else {
            this.showResendText = false;
            this.error = response.data.responseMessage;
          }
        });
      }
    },
    resendCode() {
      var body = {
        username: this.username,
        isTpn: this.isTpn.toString(),
        tpnChainId: this.tpnChainId.toString(),
        tpnSiteId: this.tpnSiteId.toString(),
        step: this.currentForm,
        email: this.email,
        resendCode: 'true'
      };

      service.VerifyLoginStep(this.apiUrl, body).then((response) => {
        this.error = "";
        if (response.data.responseCode === 200) {
          this.showResendText = true;
          var result = response.data;
          this.clientIdentity = result.clientIdentity;
        } else {
          this.error = response.data.responseMessage;
        }
      });
    },
    resetPassword() {
      var body = {
        username: this.username,
        isTpn: this.isTpn.toString(),
        tpnChainId: this.tpnChainId.toString(),
        tpnSiteId: this.tpnSiteId.toString(),
        step: this.state["RESETPASSWORD"],
        email: this.email,
      };

      service.VerifyLoginStep(this.apiUrl, body).then((response) => {
        if (response.data.responseCode === 200) {
          var result = response.data;

          if (result.nextStep == this.state.RESETVERIFYEMAIL && result.fixitNoUser?.email) {
            this.username = result.fixitNoUser?.email;
          }
          
          this.clientIdentity = result.clientIdentity;
          this.currentForm = result.nextStep;
        }
      });
    },
    resetEmail() {
      var body = {
        username: this.username,
        isTpn: this.isTpn.toString(),
        tpnChainId: this.tpnChainId.toString(),
        tpnSiteId: this.tpnSiteId.toString(),
        step: this.state["RESET_EMAIL"],
        email: this.email,
        password: this.password
      };

      service.VerifyLoginStep(this.apiUrl, body).then((response) => {
        if (response.data.responseCode === 200) {
          var result = response.data;
          this.clientIdentity = result.clientIdentity;
          this.currentForm = result.nextStep;
          this.addNewEmailProcessStarted = true;
          this.showResendText = false
        } else {
          this.error = response.data.responseMessage;
        }
      });
    },
  },
  async mounted() {
    service = await AppSvc(this.useAxios ? this.$axios : null);
    if (this.prefilledMobile !== '') {
      this.setUsername(this.prefilledMobile)
      this.VerifyStep(
        {
          username: this.username,
          isTpn: this.isTpn.toString(),
          tpnChainId: this.tpnChainId.toString(),
          tpnSiteId: this.tpnSiteId.toString(),
          step: 'check-user',
        }
      )
    }
    this.hasMounted = true
  },
  watch: {
    currentForm(oldVal, newVal) {
      if (oldVal != newVal) {
        this.error = "";
      }
    },
  },
};
</script>
<style lang="scss">
@import "../../../../assets/styles/login-method.scss";
</style>
